<template>
  <div class="wrapper">
    <div class="container">
      <div class="tags">
        <Tag
          v-for="filter in slicedFilters"
          :tag="filter"
          :key="filter.id"
          @click="toggleTag(filter)"
          class="tag-withcheckmark"
          :darkSelection="true"
          :showDomain="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueCompositionAPI, {computed} from '@vue/composition-api';
import Tag from '@common/filter-tag/tag.vue';

Vue.use(VueCompositionAPI);

export default {
  setup(props, {emit}) {
    function toggleTag(e) {
      const selectedFilters = props.filters
        .filter((f) => f.value)
        .map((filter) => {
          return {...filter, value: true};
        });
      emit('toggle-tag', [...selectedFilters, {...e, value: !e.value}]);
    }

    const availableFilters = computed(() => {
      return props.filters ? props.filters.filter((x) => x.domain === props.domain && x.name) : [];
    });

    const slicedFilters = computed(() => {
      return availableFilters.value.sort((a, b) => b.value - a.value).slice(0, 10);
    });

    const isLoading = computed(() => {
      return !slicedFilters || !availableFilters.value.length;
    });

    return {toggleTag, availableFilters, slicedFilters, isLoading};
  },

  name: 'FilterTagsRow',
  props: ['filters', 'domain', 'modal', 'text', 'click'],
  components: {
    Tag,
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  overflow: hidden;
  display: flex;
  align-items: baseline;
}
.container {
  position: relative;
  width: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;
}

.tags::-webkit-scrollbar {
  display: none;
}

.tags {
  display: flex;
  overflow: auto;
  width: 100%;
}
</style>
